class ButtonFilters extends HTMLElement {
  constructor() {
    super()
    this.btns = this.querySelectorAll(".button-filters__btn")
    this.btns.forEach((btn) =>
      btn.addEventListener("click", this.onBtnClick.bind(this)),
    )
  }

  resolveDrawer() {
    const roots = [
      this.closest(".search-overlay__filters"),
      this.closest(".search-overlay"),
      this.closest(".main-collection__container"),
      this.closest(".main-search__container"),
      this.closest(".main-collection"),
      this.closest(".main-search"),
      this.closest("#shopify-section-main-collection"),
      this.closest("#shopify-section-main-search"),
      document,
    ].filter(Boolean)

    const drawerSelector = "menu-drawer.mobile-facets__wrapper"
    for (const root of roots) {
      const drawers = root.querySelectorAll(drawerSelector)
      for (const drawer of drawers) {
        if (drawer.closest(".search-overlay.hidden")) continue
        if (!drawer.querySelector("#FacetFiltersFormMobile")) continue
        return drawer
      }
    }

    return null
  }

  onBtnClick(e) {
    const btn = e.target.classList.contains("button-filters__btn")
      ? e.target
      : e.target.closest(".button-filters__btn")

    if (!btn) return

    const filterDrawer = this.resolveDrawer()
    if (!filterDrawer) return

    const filterDrawerBtn = filterDrawer.querySelector(
      "summary.mobile-facets__open-wrapper"
    )
    if (!filterDrawerBtn) return

    const drawerDetails = filterDrawerBtn.closest("details")
    if (!drawerDetails || !drawerDetails.hasAttribute("open")) {
      filterDrawerBtn.click()
    }

    if (!btn.dataset.filter) return

    const drawerContent =
      filterDrawer.querySelector(".mobile-facets") || filterDrawer
    const relatedFilter = drawerContent.querySelector(
      `${btn.dataset.filter} summary`
    )

    if (!relatedFilter) return

    const relatedDetails = relatedFilter.closest("details")
    if (!relatedDetails || !relatedDetails.hasAttribute("open")) {
      relatedFilter.click()
    }
  }
}

if (!customElements.get("button-filters")) {
  customElements.define("button-filters", ButtonFilters)
}
